export default __webpack_public_path__ + "static/media/discover.05bc6c11.svg";